import React, { useEffect, useState } from "react";
import "./t2_sp.css";
import { callApi } from "../../../redux/action/action";
import { axiosInstance } from "../../../config/axiosConfig";
import redDot from "../../assets/images/redDot.svg";

const SubHeader = ({ setNavSelected, navSelected }) => {
  const [data, setDate] = useState();
  const navType = localStorage.getItem("type");
  console.log("data===>", data);

  useEffect(() => {
    const checkProfileCompletion = async () => {
      try {
        const id =
          localStorage.getItem("_id") || localStorage.getItem("Staffid");
        const res = await axiosInstance.get(
          `v1/LHS/staff/checkUserProfileCompletion`
        );

        setDate(res?.data.fields);

        if (res?.data?.data?.isProfileCompleted === false) {
          setProfileCompleted(false);
        }

      } catch (err) {
        console.error("Error checking profile completion:", err);
      }
    };

    if (navType === "staff") {
      checkProfileCompletion();
    }
  }, []);
  const hasIncompleteProfile = () => {
    if (!data) return false;

    return (
      data.FunctionalArea === false ||
      data.Specialization === false ||
      data.currentLocation === false ||
      data.currentProfessionalStatus === false
    );
  };
  console.log("has=====>", hasIncompleteProfile());

  return (
    <div>
      <div className="t2_subHeader mt-0">
        {(navType == "superAdmin" || navType == "admin") && (
          <>
            <button
              onClick={() => {
                setNavSelected("dashboard");
              }}
              className={
                navSelected == "dashboard"
                  ? "t2_subHeader_item t2_subHeader_item_clicked"
                  : "t2_subHeader_item"
              }
            >
              Dashboard
            </button>
            <button
              onClick={() => {
                setNavSelected("password");
              }}
              className={
                navSelected == "password"
                  ? "t2_subHeader_item t2_subHeader_item_clicked"
                  : "t2_subHeader_item"
              }
            >
              Change Password
            </button>
            {navType == "superAdmin" && (
              <button
                onClick={() => {
                  setNavSelected("advertisement");
                }}
                className={
                  navSelected == "advertisement"
                    ? "t2_subHeader_item t2_subHeader_item_clicked"
                    : "t2_subHeader_item"
                }
              >
                Advertisement
              </button>
            )}
          </>
        )}
        {navType == "staff" && (
          <>
          <button
  onClick={() => {
    setNavSelected("myprofile");
  }}
  className={
    navSelected == "myprofile"
      ? "t2_subHeader_item t2_subHeader_item_clicked"
      : "t2_subHeader_item"
  }
>
  <div className="flex items-center gap-1 justify-center">
    <span>My Profile</span>
    {/* {hasIncompleteProfile() && (
      <img
        src={redDot}
        alt="Incomplete"
        className="w-2 h-2 relative -top-1"
      />
    )} */}
  </div>
</button>


            <button
              onClick={() => {
                setNavSelected("dashboard");
              }}
              className={
                navSelected == "dashboard"
                  ? "t2_subHeader_item t2_subHeader_item_clicked"
                  : "t2_subHeader_item"
              }
            >
              Dashboard
            </button>
            {/* <button
              onClick={() => {
                setNavSelected("contact");
              }}
              className={
                navSelected == "contact"
                  ? "t2_subHeader_item t2_subHeader_item_clicked"
                  : "t2_subHeader_item"
              }
            >
              Contact Information
            </button> */}
            <button
              onClick={() => {
                setNavSelected("resume");
              }}
              className={
                navSelected == "resume"
                  ? "t2_subHeader_item t2_subHeader_item_clicked"
                  : "t2_subHeader_item"
              }
            >
              <div className="flex items-center gap-1 justify-center">
             <span>Resume</span>

                {/* {!data?.resume && (
                  <img
                    src={redDot}
                    height={"8px"}
                    width={"8px"}
                    className="w-2 h-2 relative -top-1"
                  />
                )} */}
              </div>
            </button>
            <button
              onClick={() => {
                setNavSelected("password");
              }}
              className={
                navSelected == "password"
                  ? "t2_subHeader_item t2_subHeader_item_clicked"
                  : "t2_subHeader_item"
              }
            >
              Change Password
            </button>
          </>
        )}
        {navType == "hospital" && (
          <>
            <button
              onClick={() => {
                setNavSelected("myprofile");
              }}
              className={
                navSelected == "myprofile"
                  ? "t2_subHeader_item t2_subHeader_item_clicked"
                  : "t2_subHeader_item"
              }
            >
              My Profile
            </button>
            <button
              onClick={() => {
                setNavSelected("password");
              }}
              className={
                navSelected == "password"
                  ? "t2_subHeader_item t2_subHeader_item_clicked"
                  : "t2_subHeader_item"
              }
            >
              Change Password
            </button>
            <button
              onClick={() => {
                setNavSelected("dashboard");
              }}
              className={
                navSelected == "dashboard"
                  ? "t2_subHeader_item t2_subHeader_item_clicked"
                  : "t2_subHeader_item"
              }
            >
              Dashboard
            </button>
            <button
              onClick={() => {
                setNavSelected("advertisement");
              }}
              className={
                navSelected == "advertisement"
                  ? "t2_subHeader_item t2_subHeader_item_clicked"
                  : "t2_subHeader_item"
              }
            >
              Advertisement
            </button>
          </>
        )}
        <hr style={{ color: "grey" }}></hr>
      </div>
    </div>
  );
};

export default SubHeader;
